export const createVonageSession = async (accountId: number, participantData: any) => {
  const url = `${process.env.REACT_APP_SIGNALLING_API_URL}/accounts/${accountId}/create-video-session`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(participantData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('There was a problem with the fetch operation:', error);
    throw error;
  }
};

